import type { SavPayload } from "./payload.js";

/**
 * Une seule page : les interventions (avec la suite à donner en bas). Le type
 * reste une union pour que les hôtes gardent la mécanique de wizard commune
 * au PV, mais il n'y a rien à enchaîner.
 */
export type SavStepKey = "interventions";

export type SavStep = {
  key: SavStepKey;
  /** Libellé FR par défaut (poseurs-front injecte sa traduction). */
  label: string;
  conditionalOn?: (payload: SavPayload) => boolean;
};

export const SAV_STEPS: readonly SavStep[] = [{ key: "interventions", label: "Interventions" }] as const;

export function findSavStep(key: SavStepKey): SavStep | undefined {
  return SAV_STEPS.find((step) => step.key === key);
}

export function visibleSavSteps(payload: SavPayload): SavStep[] {
  return SAV_STEPS.filter((step) => (step.conditionalOn ? step.conditionalOn(payload) : true));
}

export function nextSavStep(current: SavStepKey, payload: SavPayload): SavStepKey | undefined {
  const visible = visibleSavSteps(payload);
  const idx = visible.findIndex((s) => s.key === current);
  if (idx === -1) return undefined;
  return visible[idx + 1]?.key;
}

export function prevSavStep(current: SavStepKey, payload: SavPayload): SavStepKey | undefined {
  const visible = visibleSavSteps(payload);
  const idx = visible.findIndex((s) => s.key === current);
  if (idx <= 0) return undefined;
  return visible[idx - 1]?.key;
}
